@if (trainers && trainers.length > 0) {
  <div class="trainers-group">
    <div class="avatar-stack">
      @for (trainer of visibleTrainers; track trainer.id) {
        <div 
          class="avatar-item" 
          [title]="trainer.firstName + ' ' + trainer.lastName"
        >
          @if (trainer.imageFile?.fileUrl) {
            <img [src]="trainer.imageFile!.fileUrl" [alt]="trainer.firstName" />
          } @else {
            <span class="avatar-initials">{{ getInitials(trainer) }}</span>
          }
        </div>
      }
    </div>

    <span class="trainers-label">
      {{ primaryTrainerName }}
      @if (remainingCount > 0) {
        <span class="remaining-count">+{{ remainingCount }}</span>
      }
    </span>
  </div>
}